import React, { useState } from 'react';
import { useIntl } from 'react-intl';

import Dialog from '@/components/mui/Dialog';
import DialogContent from '@mui/material/DialogContent';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import DetailsTab from '@/pages/dokkaPay/pages/configurations/company/pages/paymentProviders/components/Providers/components/DialogPaymentProviderDetails/components/DetailsTab';
import AccountManagementTab from '@/pages/dokkaPay/pages/configurations/company/pages/paymentProviders/components/Providers/components/DialogPaymentProviderDetails/components/AccountManagementTab';

interface DialogPaymentProviderDetailsProps {
  id: string;
  onClose: () => void;
  title: string;
}

const DialogPaymentProviderDetails: React.FC<DialogPaymentProviderDetailsProps> = ({ id, onClose, title }) => {
  const { formatMessage } = useIntl();
  const [tabIndex, setTabIndex] = useState(0);

  const handleTabChange = (_event: React.SyntheticEvent, newIndex: number) => setTabIndex(newIndex);

  return (
    <Dialog
      fullScreen
      open
      onClose={onClose}
      maxWidth="sm"
      withCloseBtn
      withContent={false}
      withActions={false}
      title={title}
      sx={{ p: 4 }}
      draggable={false}
      okText={null}
      cancelText={null}
      onOk={null}
      okBtnProps={null}
    >
      <DialogContent sx={{ p: 0, display: 'flex', flexDirection: 'column' }}>
        <Box sx={{ borderBottom: 1, borderTop: 1, borderColor: 'divider' }}>
          <Tabs value={tabIndex} onChange={handleTabChange}>
            <Tab
              label={formatMessage({
                id: 'configurations.company.paymentProviders.detailsModal.tabs.accountOverview',
                defaultMessage: 'Account Overview',
              })}
            />
            <Tab
              label={formatMessage({
                id: 'configurations.company.paymentProviders.detailsModal.tabs.accountManagement',
                defaultMessage: 'Account Management',
              })}
            />
          </Tabs>
        </Box>
        <Box bgcolor="#FBFDFF" sx={{ flex: '1 1 auto' }}>
          {tabIndex === 0 && <DetailsTab id={id} />}
          {tabIndex === 1 && <AccountManagementTab providerId={id} />}
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default DialogPaymentProviderDetails;
